import React, { forwardRef, useEffect } from 'react'
// import './styles.scss'
import { Form, Formik } from 'formik'
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import store from '../../../../../store/store';
import { componentKey, setCreatePatientData, setEditDemographicsData } from '../../../AddPatient/AddPatientSlice';
import { getPreferences, savePatientPreferences } from '../../../AddPatient/AddPatientSaga';
import { getPatientDetails } from '../../PatientDashboardSaga';
import PreferencesDetails from '../../../../../containers/AddPatient/Preferences/PreferencesDetails';

const CommonDialogForAddPreferences = forwardRef(function Preferences({ isUpdate = false, onUpdateCb = null,myPrefData}, formRef) {

    const clinicalCenterNames = {
        pharmacyIds: "pharmacy",
        labIds: "lab",
        radiologyIds: "radiology"
    }

    const dispatch = useDispatch()
    const { patientId } = useParams();

    const { pharmacies, labs, radiologies, newlyAddedPatientId, fetchedPatientDetails, createPatientData } = useSelector(state => state[componentKey])

    const { PatientPharmacyIntermediate, PatientLabIntermediate, PatientRadiologyIntermediate } = fetchedPatientDetails

    const initialValues = {
        pharmacyIds: createPatientData?.preferences?.pharmacyIds?.length ? createPatientData?.preferences?.pharmacyIds : PatientPharmacyIntermediate || [],
        labIds: createPatientData?.preferences?.labIds?.length ? createPatientData?.preferences?.labIds : PatientLabIntermediate || [],
        radiologyIds: createPatientData?.preferences?.radiologyIds?.length ? createPatientData?.preferences?.radiologyIds : PatientRadiologyIntermediate || [],
    };

    useEffect(() => {
        return () => {
            if (isUpdate) {
                store.reducerManager.remove(componentKey);
            }
        }
    }, [])

    useEffect(() => {
        if (patientId && patientId !== ":id" && isUpdate) {
            dispatch(getPatientDetails({ patientId }))
        }
    }, [dispatch, patientId, isUpdate])

    useEffect(() => {
        if(myPrefData?.title === "Lab"){
            dispatch(getPreferences({ name: "lab" }));
        } else if(myPrefData?.title === "Radiology"){
            dispatch(getPreferences({ name: "radiology" }));
        }
    }, [dispatch]);

    const addClinicalCenterContact = (values, setFieldValue, storeLabel, selectVal, title) => {
        setFieldValue(storeLabel, [
            ...values[storeLabel],
            { [(title).toLowerCase()]: selectVal }
        ]);
    };

    const handleRemove = (index, values, setFieldValue, storeLabel) => {
        const clinicalCenterClone = [...values[storeLabel]];
        clinicalCenterClone.splice(index, 1);
        setFieldValue(storeLabel, clinicalCenterClone);
    };

    const data = [
     
        {
            title: myPrefData?.title,
            storeLabel: myPrefData?.storeLabel,
            placeholder: myPrefData?.placeholder,
            options: myPrefData?.title === "Lab" ?  labs:  myPrefData?.title === "Radiology"? radiologies  : labs
        },

    ];

    return (
        <>
            <Formik
                innerRef={formRef}
                initialValues={initialValues}
                enableReinitialize
                onSubmit={(values) => {
                    if (onUpdateCb) {
                        return onUpdateCb(values, patientId)
                    }
                    const payload = {
                        patientId: newlyAddedPatientId,
                    }
                    for (let key in values) {
                        payload[key] = values[key].map(item => {
                            return item[clinicalCenterNames[key]].uuid;
                        });
                    }
                    dispatch(setCreatePatientData({ preferences: values }))
                    dispatch(savePatientPreferences({ patientId: newlyAddedPatientId, payload }))
                    dispatch(setEditDemographicsData({ patientsPreferences: payload }));

                }}
            >
                {({ handleSubmit, values, setFieldValue }) => (
                    <Form onSubmit={handleSubmit}>
                        <div className='custom-patient-details bg-opacity-3 rounded flex p-5 justify-between max-h-[70vh] min-h-[50vh] overflow-auto'>
                            <div className='preferences-wrapper justify-center flex column-gap-20px row-gap-15 '>
                                {data?.map((pref, index) => (
                                    <PreferencesDetails
                                        values={values}
                                        addClinicalCenterContact={(storeLabel, selectVal, title) => addClinicalCenterContact(values, setFieldValue, storeLabel, selectVal, title)}
                                        key={index}
                                        title={pref.title}
                                        placeholder={pref.placeholder}
                                        dropdownOptions={pref.options}
                                        storeLabel={pref.storeLabel}
                                        handleRemoveCb={(index, values, storeLabel) => handleRemove(index, values, setFieldValue, storeLabel)}
                                    />
                                ))}
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </>
    );
});

export default CommonDialogForAddPreferences;